import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { openCheckout } from '../utils';
export function PurchaseSection() {
  return <section id="comprar" className="py-12 md:py-16 px-4 bg-primary text-cream relative overflow-hidden" data-id="element-167">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-168">
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary-light/40 rounded-full blur-3xl" data-id="element-169"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-accent/20 rounded-full blur-3xl" data-id="element-170"></div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-171">
        <div className="text-center mb-8" data-id="element-172">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-3" data-id="element-173">
            Empezá a transformar la salud de tu perro hoy
          </h2>
          <p className="text-xl text-cream-dark/90" data-id="element-174">
            Acceso inmediato al ebook + 4 bonos exclusivos
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white text-brown rounded-3xl p-6 md:p-10 shadow-2xl max-w-2xl mx-auto relative" data-id="element-175">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-accent text-white font-bold px-6 py-2 rounded-full shadow-lg whitespace-nowrap" data-id="element-176">
            60% DE DESCUENTO
          </div>

          <div className="mb-6 pt-3" data-id="element-177">
            <CountdownTimer data-id="element-178" />
          </div>

          <div className="text-center mb-6 border-b border-cream-dark pb-6" data-id="element-179">
            <p className="text-gray-400 line-through text-2xl font-medium mb-2" data-id="element-180">
              Precio regular: $49.990
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-181">
              <span className="text-5xl md:text-6xl font-display font-bold text-primary" data-id="element-182">
                $19.990
              </span>
              <span className="text-lg text-brown-light font-medium mt-4" data-id="element-183">
                ARS
              </span>
            </div>
            <p className="text-sm text-accent font-bold mt-2" data-id="element-184">
              ¡Único pago, acceso de por vida!
            </p>
          </div>

          <ul className="space-y-3 mb-6" data-id="element-185">
            {['Ebook: Comida Natural para Perros', 'BONO 1: Recetario de 30 comidas', 'BONO 2: Guía de transición', 'BONO 3: Alimentos prohibidos', 'BONO 4: Planificador semanal'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-186">
                <div className="bg-primary/10 p-1 rounded-full text-primary" data-id="element-187">
                  <Check size={16} className="stroke-[3]" data-id="element-188" />
                </div>
                <span className={i === 0 ? 'font-bold text-lg' : 'font-medium'} data-id="element-189">
                  {item}
                </span>
              </li>)}
          </ul>

          <button onClick={openCheckout} className="w-full bg-accent hover:bg-accent-hover text-white font-bold text-xl py-5 px-8 rounded-xl shadow-lg transform transition hover:-translate-y-1 flex flex-col items-center justify-center gap-1" data-id="element-190">
            <span data-id="element-191">QUIERO TRANSFORMAR LA SALUD DE MI PERRO</span>
            <span className="text-xs font-normal opacity-90" data-id="element-192">
              Click aquí para ir al pago seguro
            </span>
          </button>

          <div className="mt-5 flex flex-wrap justify-center gap-4 text-sm text-brown-light font-medium" data-id="element-193">
            <div className="flex items-center gap-2" data-id="element-194">
              <Lock size={16} className="text-primary" data-id="element-195" />
              <span data-id="element-196">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-197">
              <Zap size={16} className="text-primary" data-id="element-198" />
              <span data-id="element-199">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-200">
              <ShieldCheck size={16} className="text-primary" data-id="element-201" />
              <span data-id="element-202">Garantía 7 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}